import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  Heading,
  NavbarContent,
  Flex,
  Box,
  Button,
  NavbarCollapse,
  NavbarToggle,
} from "legion-ui";

const NavigationLogin = () => {
  const [activeToggle, setActiveToggle] = useState(false);

  return (
    <Navbar variant="sticky" mode="light">
      <NavbarBrand style={{ display: "flex", alignItem: "center" }}>
        <Heading size="h3" color="primary500">
          Legion
        </Heading>
        <NavbarContent>
          <Flex>
            <Button variant="transparent" css={{ marginRight: ".5rem" }}>
              Daftar
            </Button>
            <Button variant="solid">Masuk</Button>
          </Flex>
        </NavbarContent>
        <NavbarToggle onClick={() => setActiveToggle(!activeToggle)} />
      </NavbarBrand>
      <NavbarCollapse isActive={activeToggle}>
        <Box>
          <Button variant="transparent" css={{ marginRight: ".5rem" }}>
            Daftar
          </Button>
          <Button variant="solid">Masuk</Button>
        </Box>
      </NavbarCollapse>
    </Navbar>
  );
};

export default NavigationLogin;
